import { Component, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { LoadingInlineComponent } from '../../atoms/loading-inline/loading-inline.component';
import { UserDetailsComponent } from '../onboarding-v2/steps/user-details/user-details.component';
import { AlertService } from '@/app/atoms/alert/alert.service';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { AgencyDetails } from './steps/agency-details/agency-details';
import { SlickOnboardAgency } from './service/slick-onboard-agency/slick-onboard-agency';
import { AgencyBrands } from './steps/agency-brands/agency-brands';
import { AgencyCongrats } from './steps/agency-congrats/agency-congrats';
import { AdConversionsService } from '@/app/services/analytics/ad-conversions.service';

@Component({
  selector: 'app-onboarding-agency',
  imports: [
    LoadingInlineComponent, 
    UserDetailsComponent,
    AgencyDetails,
    AgencyBrands,
    AgencyCongrats,
  ],
  templateUrl: './onboarding-agency.html',
  styleUrl: './onboarding-agency.scss',
})
export class OnboardingAgency {

  showGeneralLoader = signal<boolean>(false);

  steps: { id: number, name: string, completed: boolean }[] = [
    { id: 1, name: 'User', completed: true },
    { id: 2, name: 'Agency', completed: false },
    { id: 3, name: 'Brands', completed: false },
    { id: 4, name: 'Publish', completed: false },
  ];

  currentStep = signal<number>(1);

  /** Services */
  private location = inject(Location);
  private slickOnboardAgencyService = inject(SlickOnboardAgency);
  private currentUserService = inject(CurrentUserService);
  private adConversions = inject(AdConversionsService);
  private alertService = inject(AlertService);
  /** Services - END */

  nextStep(event: boolean, step: number) {
    console.log('Onboarding AGENCY nextStep: ', event, step);

    this.steps[step - 1].completed = event;
    this.currentStep.set(step + 1);
  }

  async agencyDetailsStepComplete(event: boolean, step: number) {
    console.log('Onboarding AGENCY agencyDetailsStepComplete: ', event, step);
    this.showGeneralLoader.set(true);

    console.log('😳😳😳 Create Agency Accounts.....');

    try {
      const signUpResult: unknown = await this.slickOnboardAgencyService.registerAgencyUser();
      console.log('😳😳😳 Sign Up Result: ', signUpResult);

      if (
        signUpResult &&
        signUpResult !== false &&
        typeof signUpResult === 'object' &&
        'user' in signUpResult &&
        (signUpResult as { user: unknown }).user
      ) {
        const payload = signUpResult as { user: unknown; agency: unknown };
        this.currentUserService.setShoutUser(payload.user);
        this.currentUserService.setFocussedAgency(payload.agency);
        const agencyId = (payload.agency as { id?: string } | undefined)?.id;
        void this.adConversions.saveFirstTouch('agency', agencyId);
        this.adConversions.trackSignup('agency', agencyId);
        this.steps[step - 1].completed = event;
        this.currentStep.set(step + 1);
      }
    } catch {

    } finally {
      this.showGeneralLoader.set(false);
    }
  }

  getStepBarClass(step: { id: number, name: string, completed: boolean }): string {
    if (step.completed || step.id === this.currentStep()) {
      return 'bg-linear-to-r from-primary to-brand-studio';
    }
    return 'bg-zinc-200 dark:bg-zinc-800';
  }

  goBack() {
    this.location.back();
  }
}
